import { createStandaloneToast } from '@chakra-ui/react'

const TOAST_ID = 'forbidden'
// I95DevErrorCodes.AccessDenied. The API answers its own permission checks with a 400 carrying this code.
const ACCESS_DENIED_CODE = 'I95Dev403'
const { ToastContainer, toast } = createStandaloneToast()

export { ToastContainer }

const isForbidden = (error) => error.status === 403 || Boolean(error.data && error.data.errorCode === ACCESS_DENIED_CODE)

/**
 * Tells the user when the API refuses an action. Only for mutations: a refused read shows its own
 * empty or error state, and permission lookups may legitimately be refused.
 */
export const notifyIfForbidden = (result, api) => {
    if (api.type !== 'mutation' || !result.error || !isForbidden(result.error) || toast.isActive(TOAST_ID)) {
        return
    }
    toast({
        id: TOAST_ID,
        title: "You don't have permission to perform this action.",
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right'
    })
}
